import { AlertTriangle, ArrowLeft, ArrowRight } from "lucide-react";

export default function SelectInvoiceStep({ client, invoices, selected, onSelect, onContinue, onBack }) {
  return (
    <div className="max-w-3xl">
      <div className="bg-[#F9FAFB] border border-[#E5E7EB] rounded-lg p-4 mb-6" data-testid="invoice-gen-client-summary">
        <p className="text-[10px] uppercase tracking-[0.2em] font-semibold text-[#6B7280] mb-2">
          Account detected on this statement
        </p>
        <p className="text-sm font-semibold text-[#080808]">{client?.name || "— name not found —"}</p>
        <p className="text-xs text-[#6B7280] mt-1">
          {client?.address || "No address extracted"} {client?.phone ? `· Tel: ${client.phone}` : ""}{" "}
          {client?.email ? `· ${client.email}` : ""}
        </p>
      </div>

      <p className="text-sm font-semibold text-[#080808] mb-3">Select Invoice to Convert</p>
      <div className="flex flex-col gap-2" data-testid="invoice-gen-invoice-list">
        {invoices.map((inv) => (
          <label
            key={inv.invoice_no}
            data-testid={`invoice-gen-option-${inv.invoice_no}`}
            className={`flex items-start gap-3 border rounded-md px-4 py-3 cursor-pointer transition-colors ${
              selected === inv.invoice_no ? "border-[#3A7A8C] bg-[#F0F7F8]" : "border-[#E5E7EB] hover:border-[#C4CDD5]"
            }`}
          >
            <input
              type="radio"
              name="invoice-select"
              checked={selected === inv.invoice_no}
              onChange={() => onSelect(inv.invoice_no)}
              className="mt-1"
              data-testid={`invoice-gen-radio-${inv.invoice_no}`}
            />
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2 flex-wrap">
                <span className="font-semibold text-sm text-[#080808]">{inv.invoice_no}</span>
                <span className="text-xs text-[#6B7280]">{inv.statement_date}</span>
                <span className="text-xs font-semibold text-[#3A7A8C]">
                  ${(inv.amount ?? 0).toFixed(2)}
                </span>
                {inv.service_time && <span className="text-xs text-[#6B7280]">{inv.service_time}</span>}
                {inv.service_code && <span className="text-xs text-[#6B7280]">{inv.service_code}</span>}
                {inv.no_show && (
                  <span className="text-[10px] uppercase tracking-wide bg-[#FEF3C7] text-[#92400E] px-1.5 py-0.5 rounded">
                    No Show
                  </span>
                )}
                {inv.has_payments && (
                  <span className="text-[10px] uppercase tracking-wide bg-[#DBEAFE] text-[#1E40AF] px-1.5 py-0.5 rounded">
                    Payments on this date
                  </span>
                )}
              </div>
              {inv.therapist && (
                <p className="text-xs text-[#6B7280] mt-0.5">{inv.therapist}</p>
              )}
            </div>
          </label>
        ))}
      </div>

      {invoices.length === 0 && (
        <div className="flex items-center gap-2 text-sm text-[#92400E] bg-[#FEF3C7] border border-[#FDE68A] rounded-md px-4 py-3">
          <AlertTriangle size={16} />
          No invoice transactions were detected in this statement.
        </div>
      )}

      <div className="flex items-center gap-3 mt-8">
        <button
          type="button"
          onClick={onBack}
          data-testid="invoice-gen-back-to-upload"
          className="inline-flex items-center gap-1.5 text-sm text-[#3C4048] hover:text-[#080808]"
        >
          <ArrowLeft size={14} /> Upload a different statement
        </button>
        <button
          type="button"
          disabled={!selected}
          onClick={onContinue}
          data-testid="invoice-gen-continue-button"
          className="ash-btn-primary ml-auto inline-flex items-center gap-1.5 disabled:opacity-50"
        >
          Continue <ArrowRight size={14} />
        </button>
      </div>
    </div>
  );
}
